import React from 'react'
import { Button } from 'components/base'
import copyOnClick from 'components/Utils/copyOnClick'

const enhance = copyOnClick({
  getContentFromProps: ({ link }) => link,
})

export default enhance(function LinkCopiable({ children, onClick }) {
  return (
    <div className="flexbox flexbox-align-center padding-medium">
      <Button.Primary
        onClick={onClick}
        size="small"
        className="flexbox-no-grow font-weight-bold"
        style={{
          minWidth: 100,
          height: 40,
          padding: 0,
        }}
      >
        {children}
      </Button.Primary>
    </div>
  )
})
